import styled from '@emotion/styled'

export const RightContentContainer = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`
